import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CategoryImagesUtil } from '~app/modules/catalog/utils/category-images.util';
import { Category } from '~app/modules/generic/models';
import { environment } from '~env/environment';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { GATrackingEventType, GaTrackingEventAction, GaTrackingEventName } from '~shared/modules/ga-tracking/constants';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';

@Component({
  selector: 'app-related-category-card',
  templateUrl: './related-category-card.component.html',
  styleUrls: ['./related-category-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedCategoryCardComponent {
  @Input() category: Category;
  @Input() isMobile: boolean;
  @Input() parentCategoryName: string;

  readonly CATEGORY_PLACEHOLDER_IMG = 'images/product-catalog-placeholder.png';
  readonly MOBILE_IMAGE_SIZE = 50;
  readonly DESKTOP_AND_TABLET_IMAGE_SIZE = 70;

  market: string;
  defaultCategoryImage = `${environment.cdnBaseUrl()}/${this.CATEGORY_PLACEHOLDER_IMG}`;

  constructor(private gtmDatalayerService: GtmDatalayerService) {
    this.market = getCountryDomainCode();
  }

  onCategoryClick(): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SE_RELATED_CATEGORIES_CLICKED,
      GA_eventname: GaTrackingEventName.Interaction,
      action: GaTrackingEventAction.RELATED_CATEGORIES_CLICKED,
      label: this.category.slug,
    });
  }

  getSource(categoryId: string): string {
    const imageSize = this.isMobile ? this.MOBILE_IMAGE_SIZE : this.DESKTOP_AND_TABLET_IMAGE_SIZE;

    return CategoryImagesUtil.getCategoryImageSrc(categoryId, imageSize, imageSize);
  }

  getSourceSet(categoryId: string): string {
    const imageSize = this.isMobile ? this.MOBILE_IMAGE_SIZE : this.DESKTOP_AND_TABLET_IMAGE_SIZE;

    return CategoryImagesUtil.getCategoryImageSrcSet(categoryId, imageSize, imageSize);
  }
}
